import React, { ReactNode, useEffect } from "react";
import { ComponentProps } from "./PdfPage";
import { PDFViewer } from "@react-pdf/renderer";
import { DownloadLink } from "./DownloadLink";

interface Props extends ComponentProps {
  name: string;
  fileTag?: string;
  children: ReactNode;
}

export const Wrapper: React.FunctionComponent<Props> = (props) => {
  const [view, setView] = React.useState<ReactNode>(null);
  const [link, setLink] = React.useState<ReactNode>(null);

  // https://github.com/diegomura/react-pdf/issues/2978#issuecomment-2584584548
  useEffect(() => {
    setView(null);
    setLink(null);
    setTimeout(() => {
      setView(<PDFViewer>{props.children as any}</PDFViewer>);
      setLink(
        <DownloadLink
          show={props.show}
          doc={props.children as any}
          language={props.language}
          name={props.name}
          fileTag={props.fileTag}
        />
      );
    }, 50);
  }, [props]);

  return (
    <>
      {view}
      {link}
    </>
  );
};
